import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/events-portals',
            name: 'events-portals',
            component: () => import('@/pages/events-portals'),
            meta: { permissions: ['create events portals'], roles: ['Online designer'] }
        },
        {
            path: '/forms',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'forms',
                    component: () => import('@/pages/forms/index'),
                    meta: { permissions: ['read registrations'], roles: ['Form administrator'] }
                },
                {
                    path: 'questions',
                    name: 'forms-questions',
                    component: () => import('@/pages/forms/questions'),
                    meta: { permissions: ['read registrations'], roles: ['Form administrator'] }
                },
                {
                    path: 'copy',
                    name: 'forms-copy',
                    component: () => import('@/pages/forms/copy'),
                    meta: { permissions: ['read registrations'], roles: ['Form administrator'] }
                },
                {
                    path: 'create',
                    name: 'forms-create',
                    component: () => import('@/pages/forms/create'),
                    meta: { permissions: ['read registrations'], roles: ['Form administrator'] }
                },
                {
                    path: 'new',
                    name: 'forms-new',
                    component: () => import('@/pages/forms/id'),
                    meta: { permissions: ['read registrations'], roles: ['Form administrator'] }
                },
                {
                    path: ':id',
                    component: () => import('../layouts/layout'),
                    children: [
                        {
                            path: 'users',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: '',
                                    name: 'forms-id-users',
                                    component: () => import('@/pages/forms/id/users/index'),
                                    meta: { permissions: ['read registrations'], roles: ['Form administrator'] }
                                },
                                {
                                    path: ':uid',
                                    name: 'forms-id-users-id',
                                    component: () => import('@/pages/forms/id/users/id'),
                                    meta: { permissions: ['read registrations'], roles: ['Form administrator'] }
                                },
                            ]
                        }
                    ]
                }
            ]
        },
        {
            path: '/agreements',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'agreements',
                    component: () => import('@/pages/agreements/index'),
                    meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                },
                {
                    path: 'new',
                    name: 'agreements-new',
                    component: () => import('@/pages/agreements/id'),
                    meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                },
                {
                    path: 'inspire',
                    component: () => import('../layouts/layout'),
                    children: [
                        {
                            path: '',
                            name: 'agreements-inspire',
                            component: () => import('@/pages/agreements/inspire/index'),
                            meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                        },
                        {
                            path: ':id',
                            name: 'agreements-inspire-id',
                            component: () => import('@/pages/agreements/inspire/id'),
                            meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                        }
                    ]
                },
                {
                    path: ':id',
                    name: 'agreements-id',
                    component: () => import('@/pages/agreements/id'),
                    meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                },
                {
                    path: 'contributor/:id/tree',
                    name: 'agreements-contributor-id-tree',
                    component: () => import('@/pages/agreements/contributor/tree'),
                    meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                }
            ]
        },
        {
            path: '/analytics',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: 'daily',
                    name: 'analytics-daily',
                    component: () => import('@/pages/analytics/daily'),
                    meta: { permissions: ['analytics content'], roles: ['editorial'] }
                },
                {
                    path: 'articles',
                    name: 'analytics-articles',
                    component: () => import('@/pages/analytics/articles'),
                    meta: { permissions: ['read agreements'] }
                },
                {
                    path: 'intellitext',
                    name: 'analytics-intellitext',
                    component: () => import('@/pages/analytics/intellitext'),
                    meta: { permissions: ['read agreements'] }
                },
                {
                    path: 'downloads',
                    name: 'analytics-downloads',
                    component: () => import('@/pages/analytics/downloads'),
                    meta: { permissions: ['read agreements'], roles: ['crm', 'sales'] }
                },
                {
                    path: 'agreements',
                    component: () => import('../layouts/layout'),
                    children: [
                        {
                            path: 'office',
                            name: 'analytics-agreements-office',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: ':id',
                                    name: 'analytics-agreements-office-id',
                                    component: () => import('@/pages/analytics/agreements/office/id'),
                                    meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                                }
                            ]
                        },
                        {
                            path: 'office',
                            name: 'analytics-agreements-office-new',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: 'new/:id',
                                    name: 'analytics-agreements-office-new-id',
                                    component: () => import('@/pages/analytics/agreements/office/new/id'),
                                    meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                                }
                            ]
                        },
                        {
                            path: 'office',
                            name: 'analytics-agreements-office-report',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: 'report/:id',
                                    name: 'analytics-agreements-office-report-id',
                                    component: () => import('@/pages/analytics/agreements/office/report/id'),
                                    meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                                }
                            ]
                        },
                        {
                            path: 'section',
                            name: 'analytics-agreements-section',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: ':id',
                                    name: 'analytics-agreements-section-id',
                                    component: () => import('@/pages/analytics/agreements/section/id'),
                                    meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                                }
                            ]
                        },
                        {
                            path: 'intellitext',
                            name: 'analytics-agreements-intellitext',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: ':id',
                                    name: 'analytics-agreements-intellitext-id',
                                    component: () => import('@/pages/analytics/agreements/intellitext/id'),
                                    meta: { permissions: ['update agreements'], roles: ['crm', 'sales'] }
                                }
                            ]
                        },
                    ]
                }
            ]
        },
        {
            path: '/articles',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'articles',
                    component: () => import('@/pages/articles/index'),
                    meta: { permissions: ['create content'], roles: ['Publishing'] }
                },
                {
                    path: 'drafts',
                    component: () => import('../layouts/layout'),
                    children: [
                        {
                            path: '',
                            name: 'articles-drafts',
                            component: () => import('@/pages/articles/drafts/index'),
                            meta: { permissions: ['create content'], roles: ['Publishing'] }
                        },
                        {
                            path: ':id',
                            name: 'articles-drafts-id',
                            component: () => import('@/pages/articles/drafts/id'),
                            meta: { permissions: ['create content'], roles: ['Publishing'] }
                        },
                    ]
                },
                {
                    path: 'images/get-real-url',
                    name: 'articles-images-get-real-url',
                    component: () => import('@/pages/images/getRealUrl'),
                    meta: { permissions: ['create content'], roles: ['Publishing'] }
                }
            ]
        },

        {
            path: '/live-feed',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'live-feed',
                    component: () => import('@/pages/live-feed/index'),
                    meta: { permissions: ['create content'], roles: ['Publishing'] }
                },
                {
                    path: ':articleId',
                    component: () => import('../layouts/layout'),
                    children: [
                        {
                            path: '',
                            name: 'live-feed-articleId',
                            component: () => import('@/pages/live-feed/article/index'),
                            meta: { permissions: ['create content'], roles: ['Publishing'] }
                        },
                        {
                            path: 'create',
                            name: 'live-feed-articleId-create',
                            component: () => import('@/pages/live-feed/article/create-new'),
                            meta: { permissions: ['create content'], roles: ['Publishing'] }
                        },
                        {
                            path: 'edit/:id',
                            name: 'live-feed-articleId-edit',
                            component: () => import('@/pages/live-feed/article/create-new'),
                            meta: { permissions: ['create content'], roles: ['Publishing'] }
                        },
                    ]
                },
            ]
        },
        // {
        //     path: '/images/upload',
        //     name: 'images-upload',
        //     component: () => import('@/pages/images/upload')
        // },
        {
            path: '/categories',
            name: 'categories',
            component: () => import('@/pages/categories'),
            meta: { permissions: ['read modules'], roles: ['editorial'] }
        },
        {
            path: '/books',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'books',
                    component: () => import('@/pages/books/index'),
                    meta: { permissions: ['create events portals'], roles: ['Administrator'] }
                },
                {
                    path: 'manage',
                    name: 'books-manage',
                    component: () => import('@/pages/books/index'),
                    meta: { permissions: ['create events portals'], roles: ['Administrator'] }
                },
                {
                    path: 'test',
                    name: 'books-test',
                    component: () => import('@/pages/books/index2'),
                    meta: { permissions: ['create events portals'], roles: ['Administrator'] }
                }
            ]
        },
        {
            path: '/clients',
            name: 'clients',
            component: () => import('@/pages/clients'),
            meta: { permissions: ['read agreements'], roles: ['crm', 'sales'] }
        },
        {
            path: '/comments',
            name: 'comments',
            component: () => import('@/pages/comments'),
            meta: { permissions: ['manage comments'], roles: ['Comments moderator'] }
        },
        {
            path: '/contributors',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'contributors',
                    component: () => import('@/pages/contributors'),
                    meta: { permissions: ['read contributors'], roles: ['Editorial'] }
                },
                {
                    path: 'sync',
                    name: 'contributors-sync',
                    component: () => import('@/pages/syncContributors/index'),
                    meta: { permissions: ['read contributors'], roles: ['Editorial'] }
                }
            ]
        },
        {
            path: '/events',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'events',
                    component: () => import('@/pages/events/index'),
                    meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                },
                {
                    path: 'sync',
                    name: 'events-sync',
                    component: () => import('@/pages/events/sync'),
                    meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                },
                {
                    path: ':id',
                    component: () => import('../layouts/layout'),
                    children: [
                        {
                            path: '',
                            name: 'events-id',
                            component: () => import('@/pages/events/id/index'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'agenda',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: '',
                                    name: 'events-id-agenda',
                                    component: () => import('@/pages/events/id/agenda/index'),
                                    meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                                },
                                {
                                    path: 'timeslots',
                                    component: () => import('../layouts/layout'),
                                    children: [
                                        {
                                            path: '',
                                            name: 'events-id-agenda-timeslots',
                                            component: () => import('@/pages/events/id/agenda/timeslots/index'),
                                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                                        },
                                        {
                                            path: ':aid',
                                            name: 'events-id-agenda-timeslots-aid',
                                            component: () => import('@/pages/events/id/agenda/timeslots'),
                                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                                        },
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'news',
                            name: 'events-id-news',
                            component: () => import('@/pages/events/id/news'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'live',
                            name: 'events-id-live',
                            component: () => import('@/pages/events/id/live'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'qa',
                            name: 'events-id-qa',
                            component: () => import('@/pages/events/id/qa'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'evaluation',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: '',
                                    name: 'events-id-evaluation',
                                    component: () => import('@/pages/events/id/evaluation'),
                                    meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                                },
                                {
                                    path: 'form',
                                    name: 'events-id-evaluation-form',
                                    component: () => import('@/pages/events/id/evaluation/form'),
                                    meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                                },
                            ]
                        },
                        {
                            path: 'gallery',
                            name: 'events-id-gallery',
                            component: () => import('@/pages/events/id/gallery'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'report',
                            name: 'events-id-report',
                            component: () => import('@/pages/events/id/report'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'nominations',
                            name: 'events-id-nominations',
                            component: () => import('@/pages/events/id/nominations'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'attendance-prediction',
                            name: 'events-id-attendance-prediction',
                            component: () => import('@/pages/events/id/attendance-prediction'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'report2',
                            name: 'events-id-report2',
                            component: () => import('@/pages/events/id/report2'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'modules',
                            name: 'events-id-modules',
                            component: () => import('@/pages/events/id/modules'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'pricing',
                            name: 'events-id-pricing',
                            component: () => import('@/pages/events/id/pricing/index'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'submission',
                            name: 'events-id-submission',
                            component: () => import('@/pages/events/id/submission'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'matchmaking',
                            name: 'events-id-matchmaking',
                            component: () => import('@/pages/events/id/matchmaking'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'advisory-board',
                            name: 'events-id-advisory-board',
                            component: () => import('@/pages/events/id/advisory-board'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'reminder',
                            name: 'events-id-reminder',
                            component: () => import('@/pages/events/id/reminder'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'registration-desk',
                            name: 'events-id-registration-desk',
                            component: () => import('@/pages/events/id/registration-desk'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'transactions',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: '',
                                    name: 'events-id-transactions',
                                    component: () => import('@/pages/events/id/transactions'),
                                    meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                                },
                                {
                                    path: ':tid',
                                    component: () => import('../layouts/layout'),
                                    children: [
                                        {
                                            path: ':lines',
                                            name: 'events-id-transactions-tid-lines',
                                            component: () => import('@/pages/events/id/transactions/tid/lines'),
                                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            path: 'mailshots',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: '',
                                    name: 'events-id-mailshots',
                                    component: () => import('@/pages/mailshots/index'),
                                    meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                                },
                                {
                                    path: ':mailId',
                                    name: 'events-id-mailshots-mailId',
                                    component: () => import('@/pages/mailshots/id'),
                                    meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                                }
                            ]
                        },
                        {
                            path: 'storage',
                            name: 'events-id-storage',
                            component: () => import('@/pages/events/id/storage'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                        {
                            path: 'qa/:trackId/:timeslotId',
                            name: 'events-id-qa-track-timeslot',
                            component: () => import('@/pages/events/id/qa/timeslot'),
                            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                        },
                    ]
                }
            ]
        },
        {
            path: '/frontpage',
            name: 'frontpage',
            component: () => import('@/pages/frontpage'),
            meta: { permissions: ['read layouts'], roles: ['editorial'] }
        },
        {
            path: '/ict-insight',
            name: 'ict-insight',
            component: () => import('@/pages/ict-insight'),
            meta: { permissions: ['read ictinsight'], roles: ['Administrator'] }
        },
        {
            path: '/',
            name: 'index',
            component: () => import('@/pages/index')
        },
        {
            path: '/tables',
            name: 'tables',
            component: () => import('@/pages/tables'),
            meta: { permissions: ['read registrations'], roles: ['Form administrator'] }
        },
        {
            path: '/tables/floor-plan',
            name: 'tables-floor-plan',
            component: () => import('@/pages/tables/floor-plan'),
            meta: { permissions: ['read registrations'], roles: ['Form administrator'] }
        },
        {
            path: '/qrcode',
            name: 'qrcode',
            component: () => import('@/pages/qrcode')
        },
        {
            path: '/search',
            name: 'search',
            component: () => import('@/pages/search'),
            meta: { permissions: ['read qrcode'], roles: ['Administrator'] }
        },
        {
            path: '/nominations',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'nominations',
                    component: () => import('@/pages/nominations/index'),
                    meta: { permissions: ['read nominations', 'update nominations'], roles: ['Nominations'] }
                },
                {
                    path: ':id',
                    component: () => import('../layouts/layout'),
                    children: [
                        {
                            path: '',
                            name: 'nominations-id',
                            component: () => import('@/pages/nominations/id/index'),
                            meta: { permissions: ['read nominations', 'update nominations'], roles: ['Nominations'] }
                        },
                    ]
                }
            ]
        },
        {
            path: '/layouts',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'layouts',
                    component: () => import('@/pages/layouts/index'),
                    meta: { permissions: ['read layouts', 'ordering layouts'], roles: ['Editorial'] }
                },
                {
                    path: ':slug',
                    component: () => import('../layouts/layout'),
                    children: [
                        {
                            path: '',
                            name: 'layouts-slug',
                            component: () => import('@/pages/layouts/index'),
                            meta: { permissions: ['read layouts', 'ordering layouts'], roles: ['Editorial'] }
                        },
                        {
                            path: 'mailchimp-stats',
                            name: 'layouts-slug-stats',
                            component: () => import('@/pages/layouts/stats'),
                            meta: { permissions: ['read layouts', 'ordering layouts'], roles: ['Editorial'] }
                        }
                    ]
                }
            ]
        },
        {
            path: '/domainstats',
            name: 'domainstats',
            component: () => import('@/pages/domainstats/index'),
            meta: { permissions: ['read domainstats'], roles: ['Editorial'] }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/pages/login')
        },
        {
            path: '/menu',
            name: 'menu',
            component: () => import('@/pages/menu'),
            meta: { permissions: ['manage menu'], roles: ['Menu Administrator'] }
        },
        {
            path: '/modules',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'modules',
                    component: () => import('@/pages/modules/index'),
                    meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
                }
            ]
        },
        {
            path: '/office',
            name: 'office',
            component: () => import('@/pages/office'),
            meta: { permissions: ['create office'], roles: ['Administrator'] }
        },
        {
            path: '/registrations',
            name: 'registrations',
            component: () => import('@/pages/registrations')
        },
        {
            path: '/spotlight',
            name: 'spotlight',
            component: () => import('@/pages/spotlight'),
            meta: { permissions: ['read modules'], roles: ['Editorial'] }
        },
        {
            path: '/cartoons',
            name: 'cartoons',
            component: () => import('@/pages/cartoons'),
            meta: { permissions: ['read modules'], roles: ['Editorial'] }
        },
        {
            path: '/surveys',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'surveys',
                    component: () => import('@/pages/surveys/index'),
                    meta: { permissions: ['read surveys'], roles: ['survey'] }
                },
                {
                    path: ':id',
                    component: () => import('../layouts/layout'),
                    children: [
                        {
                            path: 'tabs',
                            name: 'surveys-id-tabs',
                            component: () => import('@/pages/surveys/id/tabs'),
                            meta: { permissions: ['read surveys'], roles: ['survey'] }
                        },
                        {
                            path: 'graph',
                            name: 'surveys-id-graph',
                            component: () => import('@/pages/surveys/id/graph'),
                            meta: { permissions: ['read surveys'], roles: ['survey'] }
                        },
                        {
                            path: 'forms',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: ':form',
                                    component: () => import('../layouts/layout'),
                                    children: [
                                        {
                                            path: 'validate',
                                            name: 'surveys-id-forms-form-validate',
                                            component: () => import('@/pages/surveys/id/forms/form/validate'),
                                            meta: { permissions: ['read surveys'], roles: ['survey'] }
                                        },
                                    ]
                                }

                            ]
                        },
                        {
                            path: 'mailshots',
                            component: () => import('../layouts/layout'),
                            children: [
                                {
                                    path: '',
                                    name: 'surveys-id-mailshots',
                                    component: () => import('@/pages/mailshots/index'),
                                    meta: { permissions: ['read surveys'], roles: ['survey'] }
                                },
                                {
                                    path: ':mailId',
                                    name: 'surveys-id-mailshots-mailId',
                                    component: () => import('@/pages/mailshots/id'),
                                    meta: { permissions: ['read surveys'], roles: ['survey'] }
                                }
                            ]
                        },
                    ]
                },
                {
                    path: 'graph',
                    name: 'surveys-graph',
                    component: () => import('../layouts/layout'),
                    children: [
                        {
                            path: ':id',
                            name: 'surveys-graph-id',
                            component: () => import('@/pages/surveys/graph/id'),
                            meta: { permissions: ['read surveys'], roles: ['survey'] }
                        },
                    ]
                },
            ]
        },
        {
            path: '/videos',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'videos',
                    component: () => import('@/pages/videos/index'),
                    meta: { permissions: ['manage videos'], roles: ['Videographer'] }
                },
                {
                    path: 'categories',
                    name: 'videos-categories',
                    component: () => import('@/pages/videos/categories/index'),
                    meta: { permissions: ['manage videos'], roles: ['Videographer'] }
                },
                {
                    path: ':id',
                    name: 'videos-id',
                    component: () => import('@/pages/videos/id'),
                    meta: { permissions: ['manage videos'], roles: ['Videographer'] }
                },
            ]
        },
        {
            path: '/roomControl',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'roomControl',
                    component: () => import('@/pages/roomControl/index'),
                    meta: { permissions: ['manage event platform'], roles: ['Event Platform Administrator'] }
                },
                {
                    path: 'notification',
                    name: 'roomControl-notification',
                    component: () => import('@/pages/roomControl/notification'),
                    meta: { permissions: ['manage event platform'], roles: ['Event Platform Administrator'] }
                },
                {
                    path: ':id',
                    name: 'roomControl-id',
                    component: () => import('@/pages/roomControl/id'),
                    meta: { permissions: ['manage event platform'], roles: ['Event Platform Administrator'] }
                },
            ]
        },
        {
            path: '/user',
            component: () => import('../layouts/layout'),
            children: [
                { path: '', redirect: 'management' },
                {
                    path: 'management',
                    name: 'user-management',
                    component: () => import('@/pages/user/layout'),
                    meta: { permissions: ['manage acl', 'manage consent'], roles: ['Administrator'] }
                },
                { path: 'roles', name: 'user-roles', redirect: { name: 'user-management' } },
                { path: 'permissions', name: 'user-permissions', redirect: { name: 'user-management' } },
            ]
        },
        {
            path: '/admin/http',
            name: 'admin-http',
            component: () => import('@/pages/admin/http'),
            meta: { permissions: ['manage transactions'], roles: ['Administrator'] }
        },
        {
            path: '/subscriber',
            name: 'subscriber',
            component: () => import('@/pages/subscriber'),
            meta: { permissions: ['manage subscribers'], roles: ['Circulation'] }
        },
        //This is probably not used anywhere
        {
            path: '/cio-table',
            name: 'cio-table',
            component: () => import('@/pages/cioTable/index'),
            meta: { permissions: ['read qrcode'], roles: ['Administrator'] }

        },
        {
            path: '/sync-terms',
            name: 'sync-terms',
            component: () => import('@/pages/syncTerms/index'),
            meta: { permissions: ['manage sensitive data'], roles: ['Administrator'] }
        },
        // {
        //     path: '/dilbert',
        //     name: 'dilbert',
        //     component: () => import('@/pages/dilbert/index')
        // },
        //This is probably not used anywhere
        {
            path: '/mailchimp',
            name: 'mailchimp',
            component: () => import('@/pages/mailchimp/index'),
            meta: { permissions: ['read layouts', 'ordering layouts'], roles: ['Administrator'] }
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: () => import('@/pages/calendar/index'),
            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
        },
        {
            path: '/featured-artist',
            name: 'featured-artist',
            component: () => import('@/pages/featured-artist/index'),
            meta: { permissions: ['read modules', 'manage events'], roles: ['Editorial'] }
        },
        {
            path: '/sponsored-words',
            name: 'sponsored-words',
            component: () => import('@/pages/sponsored-words/index'),
            meta: { permissions: ['manage advertising'], roles: ['crm'] }
        },
        {
            path: '/transcriptions',
            name: 'transcriptions',
            component: () => import('@/pages/transcriptions'),
            meta: { permissions: ['create transcriptions'], roles: ['Transcriptions moderator'] }
        },
        {
            path: '/google-search-import',
            name: 'google-search-import',
            component: () => import('@/pages/google-search/import'),
            meta: { permissions: ['manage sensitive data'], roles: ['Administrator'] }
        },
        {
            path: '/section-balancing',
            name: 'section-balancing',
            component: () => import('@/pages/section-balancing/section-balancing'),
            meta: { permissions: ['manage advertising'], roles: ['crm'] }
        },
        {
            path: '/vertex-ai',
            name: 'vertex-ai',
            component: () => import('@/pages/vertex/index'),
            meta: { permissions: ['create office'], roles: ['Administrator'] }
        },
        {

            path: '/directories-leads',
            component: () => import('../layouts/layout'),
            children: [
                {
                    path: '',
                    name: 'directories-leads',
                    component: () => import('@/pages/directories/leads/index'),
                    meta: { permissions: ['manage directory'], roles: ['Directory'] }
                },
                {
                    path: ':slug',
                    name: 'directories-leads-slug',
                    component: () => import('@/pages/directories/leads/slug'),
                    meta: { permissions: ['manage directory'], roles: ['Directory'] }
                }
            ]
        },
        {
            path: '/fcm',
            name: 'fcm',
            component: () => import('@/pages/fcm/index'),
            meta: { permissions: ['send global notification'], roles: ['Notification'] }
        },
        {
            path: '/fcm-logs',
            name: 'fcm-logs',
            component: () => import('@/pages/fcm-logs/index'),
            meta: { permissions: ['send global notification'], roles: ['Notification'] }
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})
